/* eslint-disable jsx-a11y/img-redundant-alt */
import parse, { domToReact } from 'html-react-parser';
import { ScreenRecordMain, Printscreen, SvgDiv } from './styles';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import React, { RefObject, useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { RenderImagePreview } from '../renderImagePreview';
import { isElectronApp } from '../../helpers/common';
import Button from '../button';
import { BUTTON_TYPE, ICON_SIZE } from '../../global/constants';
import Image from '../image';
import TaskLinkEmbedCard from '../taskLinkEmbed';
import ProjectEmbedCard from '../projectEmbedCard';

function RenderInbox({ htmlString }: { htmlString: string }) {
  //Refs
  const videoRef: RefObject<
    HTMLVideoElement & {
      mozRequestFullScreen?: () => void;
      webkitRequestFullscreen?: () => void;
      msRequestFullscreen?: () => void;
    }
  > = useRef(null);
  // Can't define type for playerRef
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const playerRef: any = useRef<HTMLDivElement>(null);
  //States
  const [isPlaying, setIsPlaying] = useState(false);
  const [oncePlay, setOncePlay] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = (isYoutubeVideo: boolean, videoUrl: string) => {
    if (!isYoutubeVideo) {
      if (videoRef.current?.requestFullscreen) {
        if (isElectronApp()) {
          window.open(videoUrl, '_blank');
        } else {
          videoRef.current.requestFullscreen();
        }
      } else if (videoRef.current?.mozRequestFullScreen) {
        videoRef.current.mozRequestFullScreen();
      } else if (videoRef.current?.webkitRequestFullscreen) {
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current?.msRequestFullscreen) {
        videoRef.current.msRequestFullscreen();
      }
    } else {
      if (playerRef.current) {
        const wrapper = playerRef.current;
        if (wrapper.requestFullscreen) {
          if (isElectronApp()) {
            window.open(videoUrl, '_blank');
          } else {
            wrapper.requestFullscreen();
          }
        } else if (wrapper.mozRequestFullScreen) {
          wrapper.mozRequestFullScreen();
        } else if (wrapper.webkitRequestFullscreen) {
          wrapper.webkitRequestFullscreen();
        } else if (wrapper.msRequestFullscreen) {
          wrapper.msRequestFullscreen();
        }
      }
    }
  };

  const handleFullscreenChange = () => {
    const fullscreenElement =
      document.fullscreenElement ||
      playerRef?.current?.webkitFullscreenElement ||
      playerRef?.current?.mozFullScreenElement ||
      playerRef?.current?.msFullscreenElement;

    if (fullscreenElement === playerRef.current) {
      setIsFullscreen(true);
    } else {
      setIsFullscreen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
    document.addEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
    };
  }, []);

  const renderYoutubeVideo = (e: React.SyntheticEvent, videoUrl: string) => {
    e.stopPropagation();
    setOncePlay(true);
    setIsPlaying(true);
    toggleFullscreen(true, videoUrl);
  };

  const renderCleanshotVideo = (e: React.SyntheticEvent, videoUrl: string) => {
    e.stopPropagation();
    toggleFullscreen(false, videoUrl);
  };

  const handleViewImage = (e: React.SyntheticEvent, imageUrl: string) => {
    e.stopPropagation();
    window.open(imageUrl, '_blank');
  };
  return (
    <>
      {parse(`<div>${htmlString}</div>`, {
        // Can't define type for domNode
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        replace: (domNode: any) => {
          // Handle image upload embed spans
          if (
            domNode.type === 'tag' &&
            domNode.name === 'div' &&
            domNode.attribs?.['data-type'] === 'image-upload-embed' &&
            domNode.attribs?.['src']
          ) {
            return (
              <RenderImagePreview
                imageUrl={domNode.attribs['src']}
                altText='Uploaded image'
                isImage={true}
                type='Image'
              />
            );
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'img' &&
            domNode?.attribs?.class?.includes('figma-preview-image')
          ) {
            return (
              <RenderImagePreview imageUrl={domNode.attribs.src} altText={domNode.attribs.alt} ShowImageBorder={true} />
            );
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'img' &&
            !domNode?.attribs?.class?.includes('figma-icon') &&
            !domNode?.attribs?.class?.includes('refresh-icon') &&
            !domNode?.attribs?.class?.includes('figma-preview-image') &&
            !domNode?.attribs?.class?.includes('embed-icon')
          ) {
            return (
              <RenderImagePreview
                imageUrl={domNode.attribs.src}
                altText={domNode.attribs.alt}
                ShowImageBorder={true}
                isMargin={true}
              />
            );
          } else if (domNode.type === 'tag' && domNode?.attribs?.class?.includes('screen-recording-custom-main-div')) {
            return (
              <ScreenRecordMain>
                <div className='video-preview'>
                  <div className='screen-recording-header'>
                    <div className='screen-recording-desc-div'>
                      <div className='screen-recording-text'>
                        <div className='header'>
                          <SvgDiv>
                            <SVGIcon
                              name='snap-icon'
                              width={ICON_SIZE.XL}
                              height={ICON_SIZE.XL}
                              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                              fill='var(--brand-primary)'
                            />
                          </SvgDiv>
                          <div className='screen-recording-name'>{domNode?.attribs?.name}</div>
                        </div>
                        <Button
                          onClick={(e: React.MouseEvent) => {
                            e.stopPropagation();
                            toggleFullscreen(false, domNode?.attribs?.url);
                          }}
                          title=' Play Video'
                          size='small'
                          variant={BUTTON_TYPE.SECONDARY}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    role='button'
                    className='inbox-image-container'
                    tabIndex={0}
                    onClick={(e) => e.stopPropagation()}>
                    <video ref={videoRef} controls={false} className='inbox-video'>
                      <source type='video/mp4' src={domNode?.attribs?.url} />
                      <source type='video/webm' src={domNode?.attribs?.url.replace(/\.mp4$/i, '.webm')} />
                    </video>
                  </div>
                </div>
              </ScreenRecordMain>
            );
          } else if (domNode.type === 'tag' && domNode?.attribs?.class?.includes('cleanshot-video-main-div')) {
            return (
              <ScreenRecordMain>
                <div className='video-preview'>
                  <div className='screen-recording-header'>
                    <div className='screen-recording-desc-div'>
                      <div className='screen-recording-text'>
                        <div className='header'>
                          <SvgDiv>
                            <Image
                              imageKey='cleanshot_icon'
                              alt='cleanShot Image'
                              width='20px'
                              height='20px'
                              className='img-cleanShot'
                            />
                          </SvgDiv>
                          <div className='screen-recording-name'>{domNode?.attribs?.name}</div>
                        </div>
                        <Button
                          onClick={(e: React.MouseEvent) => renderCleanshotVideo(e, domNode?.attribs?.url)}
                          title=' Play Video'
                          size='small'
                          variant={BUTTON_TYPE.SECONDARY}
                        />
                      </div>
                    </div>
                  </div>
                  <div role='button' className='inbox-image-container' onClick={(e) => e.stopPropagation()}>
                    <video ref={videoRef} controls={false} className='inbox-video'>
                      <source type='video/mp4' src={domNode?.attribs?.url} />
                      <source type='video/webm' src={domNode?.attribs?.url.replace(/\.mp4$/i, '.webm')} />
                    </video>
                  </div>
                </div>
              </ScreenRecordMain>
            );
          } else if (domNode.type === 'tag' && domNode?.attribs?.class?.includes('figma-link-div')) {
            return (
              <>
                <Button
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleViewImage(e, domNode?.attribs?.href)}
                  title='Open in Figma'
                  size='small'
                  variant={BUTTON_TYPE.SECONDARY}
                />
              </>
            );
          } else if (domNode.type === 'tag' && domNode?.attribs?.class?.includes('prnt-preview-main-div')) {
            return (
              <Printscreen>
                <div className='prnt-screen-box'>
                  <div>
                    <div className='prnt-screen-header'>
                      <div className='prnt-screen-text'>
                        <div className='header'>
                          <Image
                            imageKey='prntscrn_icon'
                            alt='Lightshot Image'
                            width='20px'
                            height='20px'
                            className='logo'
                          />
                          <div className='prnt-screen-title'>{domNode?.attribs?.url}</div>
                        </div>
                        <div className='buttons'>
                          <Button
                            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                              e.stopPropagation();
                              const url = domNode?.attribs?.url;
                              if (url) {
                                window.open(url, '_blank', 'noreferrer');
                              }
                            }}
                            title='Open Link'
                            size='small'
                            variant={BUTTON_TYPE.SECONDARY}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role='button'
                    className='figma-image-container'
                    tabIndex={0}
                    onClick={(e) => e.stopPropagation()}>
                    <RenderImagePreview imageUrl={domNode.attribs.name} altText={'prnt image'} ShowImageBorder={true} />
                  </div>
                </div>
              </Printscreen>
            );
          } else if (domNode.type === 'tag' && domNode?.attribs?.class?.includes('cleanshot-image-main-div')) {
            return (
              <Printscreen>
                <div className='prnt-screen-box'>
                  <div>
                    <div className='prnt-screen-header'>
                      <div className='prnt-screen-text'>
                        <div className='header'>
                          <Image
                            imageKey='cleanshot_icon'
                            alt='cleanshot Image'
                            width='20px'
                            height='20px'
                            className='logo'
                          />
                          <div className='prnt-screen-title'>{domNode?.attribs?.name}</div>
                        </div>
                        <div className='buttons'>
                          <a
                            href={domNode?.attribs?.name}
                            target='_blank'
                            rel='noreferrer'
                            className='button'
                            onClick={(e) => e.stopPropagation()}>
                            Open Link
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role='button'
                    className='figma-image-container'
                    tabIndex={0}
                    onClick={(e) => e.stopPropagation()}>
                    <RenderImagePreview imageUrl={domNode.attribs.name} altText={'prnt image'} ShowImageBorder={true} />
                  </div>
                </div>
              </Printscreen>
            );
          } else if (domNode.type === 'tag' && domNode.attribs?.class?.includes('youtube-preview-main-div')) {
            return (
              <>
                <ScreenRecordMain>
                  <div className='video-preview youtube-inbox-embed'>
                    <div className='screen-recording-header'>
                      <div className='screen-recording-desc-div'>
                        <div className='screen-recording-text'>
                          <div className='header'>
                            <SvgDiv>
                              <SVGIcon
                                name='snap-icon'
                                width={ICON_SIZE.XL}
                                height={ICON_SIZE.XL}
                                viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                                fill='var(--brand-primary)'
                              />
                            </SvgDiv>
                            <div className='screen-recording-name'>{`YouTube_video_${domNode?.attribs?.name}`}</div>
                          </div>
                          <Button
                            onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                              renderYoutubeVideo(e, `https://www.youtube.com/watch?v=${domNode?.attribs?.name}`)
                            }
                            title='Play Video'
                            size='small'
                            variant={BUTTON_TYPE.SECONDARY}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      role='button'
                      className='inbox-image-container'
                      tabIndex={0}
                      onClick={(e) => e.stopPropagation()}>
                      <Image
                        src={`https://img.youtube.com/vi/${domNode?.attribs?.name}/maxresdefault.jpg`}
                        alt='YouTube Preview'
                        className='youtube-preview-image'
                        width='200'
                        height='100'
                      />
                    </div>
                  </div>
                </ScreenRecordMain>
                <div ref={playerRef}>
                  {isFullscreen && oncePlay && (
                    <ReactPlayer
                      url={`https://www.youtube.com/watch?v=${domNode?.attribs?.name}`}
                      playing={isPlaying}
                      controls={true}
                      height='100%'
                      width='100%'
                      config={{
                        youtube: {
                          playerVars: {
                            modestbranding: 1, // Minimal branding
                            showinfo: 0, // Hide video info
                            controls: 1, // Show YouTube controls
                            disablekb: 0, // Enable keyboard controls for seeking
                            iv_load_policy: 3, // Hide annotations
                            fs: 1, // Allow full-screen
                            rel: 0 // Don't show related videos
                          }
                        }
                      }}
                      onPause={() => setIsPlaying(false)}
                      onPlay={() => setIsPlaying(true)}
                      onEnded={() => setIsPlaying(false)}
                    />
                  )}
                </div>
              </>
            );
          } else if (domNode.type === 'tag' && domNode.name === 'table') {
            return <div className='tableWrapper'>{domToReact([domNode])}</div>;
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'div' &&
            domNode?.attribs?.class?.includes('project-link-embed-preview-main-div')
          ) {
            return (
              <div role='presentation' onClick={(e) => e.stopPropagation()}>
                <ProjectEmbedCard node={domNode} />
              </div>
            );
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'div' &&
            domNode?.attribs?.class?.includes('task-link-preview-main-div')
          ) {
            return (
              <div role='presentation' onClick={(e) => e.stopPropagation()}>
                <TaskLinkEmbedCard node={domNode} />
              </div>
            );
          }
          return domNode;
        }
      })}
    </>
  );
}
export default RenderInbox;
